import { Typography, Grid2 } from "@mui/material";
import { Link } from "react-router-dom";
import CommonSKillVationLoginForm from "../../feature/Login/skillvationLogins/CommonSKillVationLoginForm";

const TeacherLoginForm = () => {
  const bottomLine = (
    <Grid2 size={12} display="flex" justifyContent="center" gap={0.5}>
      <Typography variant="body2" fontSize="12px">
        If you don't have an account !!
      </Typography>
      <Link to="/TeacherSignUp">
        <Typography variant="body2" fontSize="12px" color="#2563EB">
          Sign Up
        </Typography>
      </Link>
    </Grid2>
  );

  return (
    <CommonSKillVationLoginForm
      loginRoute="teachers/login"
      bottomLine={bottomLine}
    />
  );
};

export default TeacherLoginForm;